import React from "react";

export function Swatch({ hex, size = "lg", className = "" }) {
  const dim = size === "lg" ? "h-16 w-16" : size === "sm" ? "h-6 w-6" : "h-10 w-10";
  return (
    <span
      className={`inline-block ${dim} border border-[#F5F2EA]/15 ${className}`}
      style={{ backgroundColor: hex }}
      aria-hidden="true"
    />
  );
}

export function ScoreBadge({ score, outOf = 10, testid }) {
  return (
    <div className="text-right" data-testid={testid}>
      <div className="font-serif text-3xl text-[#C8A97E] leading-none">{Number(score).toFixed(1)}</div>
      <div className="font-sans text-[9px] tracking-luxe text-[#8A8170] uppercase mt-1">/ {outOf}</div>
    </div>
  );
}
